/**
 * @file TemplateIssueList.tsx
 * @description Замечания шаблона страницы товара под проверкой публикации
 * (phase19.16 Р2а; uiux-design-r2a §6; контракт §19.4: строка
 * `site_product_template_invalid` с `issues: TemplateIssue[]`): каждое
 * замечание строкой, у пропавшего или скрытого обязательного элемента —
 * «Вернуть элемент» (в черновик шаблона, затем проверки заново).
 */

import type { ProductRequiredKind, TemplateIssue } from "@chaiberi/shared";
import { useState } from "react";

import { Button } from "../../ui/button";
import { restorableKind } from "../../../lib/site-builder/template-restore";

interface Props {
  issues: readonly TemplateIssue[];
  /** Вернуть элемент; нет — кнопки нет (окно отката версии). */
  onRestore?: (kind: ProductRequiredKind) => Promise<void>;
}

export function TemplateIssueList({ issues, onRestore }: Props) {
  const [busy, setBusy] = useState<ProductRequiredKind | null>(null);
  const errors = issues.filter((i) => i.level === "error");
  if (errors.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1 pt-1">
      {errors.map((issue, i) => {
        const kind = restorableKind(issue);
        return (
          <li key={`${issue.code}:${issue.elementId ?? i}`} className="type-caption flex flex-wrap items-center gap-x-2 gap-y-1 text-on-surface-variant">
            <span className="min-w-0 flex-1">{issue.message}</span>
            {kind && onRestore ? (
              <Button
                variant="outline"
                size="sm"
                className="max-lg:min-h-12"
                loading={busy === kind}
                onClick={() => {
                  setBusy(kind);
                  void onRestore(kind).finally(() => setBusy(null));
                }}
              >
                Вернуть элемент
              </Button>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}
